<template>
  <section id="party" class="section section-observed party-section party-route-page">
    <div class="party-layout">
      <header class="party-theme-banner" :aria-label="front.activePartyTitle">
        <span class="party-theme-banner__deco party-theme-banner__deco--left" aria-hidden="true">
          <svg viewBox="0 0 220 160" xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor">
              <path d="M18 18l4.2 12.8H36l-11.2 8.2 4.3 13.2L18 43.8 6.9 52.2l4.3-13.2L0 30.8h13.8z" />
              <path d="M48 8l3 9.2H61l-8 5.9 3 9.5-8-5.8-8 5.8 3-9.5-8-5.9h10z" />
              <path d="M78 22l2.4 7.4h7.8l-6.3 4.6 2.4 7.5-6.3-4.6-6.3 4.6 2.4-7.5-6.3-4.6h7.8z" />
              <path d="M28 92h124v8H28z" />
              <path d="M36 100h108v10H36z" />
              <rect x="44" y="110" width="16" height="28" />
              <rect x="70" y="110" width="20" height="28" />
              <rect x="100" y="110" width="20" height="28" />
              <rect x="130" y="110" width="16" height="28" />
              <path d="M40 86h100l-8-18H48z" />
              <rect x="82" y="62" width="16" height="24" />
              <path d="M78 62h24l-4-10h-16z" />
            </g>
          </svg>
        </span>
        <span class="party-theme-banner__deco party-theme-banner__deco--right" aria-hidden="true">
          <svg viewBox="0 0 180 160" xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor">
              <path d="M148 10l3.4 10.4h11l-8.9 6.5 3.4 10.5-8.9-6.5-8.9 6.5 3.4-10.5-8.9-6.5h11z" />
              <path d="M118 28l2.4 7.4h7.8l-6.3 4.6 2.4 7.5-6.3-4.6-6.3 4.6 2.4-7.5-6.3-4.6h7.8z" />
              <rect x="86" y="48" width="12" height="92" rx="2" />
              <path d="M78 46h28l-4 10H82z" />
              <path d="M72 70c8-10 20-10 28 0-8 4-20 4-28 0z" />
              <path d="M70 88c10-8 24-8 34 0-10 4-24 4-34 0z" />
              <circle cx="92" cy="42" r="8" />
              <path d="M84 138h28v8H84z" />
            </g>
          </svg>
        </span>
        <div class="party-theme-banner__inner">
          <h1>{{ front.activePartyTitle }}</h1>
          <p v-if="front.pageSubtitle">{{ front.pageSubtitle }}</p>
          <button
            v-if="!front.isPartyHub"
            type="button"
            class="party-theme-banner__back"
            @click="front.goPath('/party')"
          >
            返回党建文化中心
          </button>
        </div>
      </header>

      <div class="party-content">
        <div class="party-panel">
          <div v-if="front.isPartyHub" class="party-hub">
            <div class="party-hub-grid">
              <button
                v-for="item in front.partyNavItems"
                :key="item.path"
                type="button"
                class="party-hub-card"
                @click="front.goPath(item.path)"
              >
                <strong>{{ item.label }}</strong>
                <span class="party-hub-card-desc">{{ item.subtitle }}</span>
                <span class="party-hub-card-link">进入栏目 →</span>
              </button>
            </div>
          </div>

          <template v-else>
            <PartySubnav v-if="showSubnav" :items="subnavItems" @select="onSubnavSelect" />
            <ReportingSection v-if="layout === 'reporting'" />
            <PartyDirectoryGrid v-else-if="layout === 'directory'" :section="ctx.section" />
            <PartyRichtextPanel v-else-if="layout === 'richtext'" />
            <PartyTopicPanel v-else-if="layout === 'topics'" />
            <PartyDownloadPanel v-else-if="layout === 'downloads'" />
            <PartyCardGrid v-else-if="layout === 'cards' || layout === 'theory'" />
            <PartyEntryList v-else />
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ReportingSection from './ReportingSection.vue'
import PartySubnav from './PartySubnav.vue'
import PartyDirectoryGrid from './PartyDirectoryGrid.vue'
import PartyEntryList from './PartyEntryList.vue'
import PartyCardGrid from './PartyCardGrid.vue'
import PartyRichtextPanel from './PartyRichtextPanel.vue'
import PartyTopicPanel from './PartyTopicPanel.vue'
import PartyDownloadPanel from './PartyDownloadPanel.vue'

export default {
  name: 'PartySection',
  components: {
    ReportingSection,
    PartySubnav,
    PartyDirectoryGrid,
    PartyEntryList,
    PartyCardGrid,
    PartyRichtextPanel,
    PartyTopicPanel,
    PartyDownloadPanel
  },
  inject: ['front'],
  computed: {
    ctx() {
      return this.front.activePartyContext
    },
    layout() {
      return (this.ctx && this.ctx.layout) || null
    },
    subnavItems() {
      const ctx = this.ctx
      if (!ctx || !ctx.section) return []
      const categories = ctx.section.categories || []
      if (ctx.section.layout === 'list' && categories.length) {
        const cat = (ctx.child && ctx.child.category) || this.front.partyCategoryFilter || ''
        return [
          { key: '', label: '全部', active: !cat, cat: '' },
          ...categories.map((name) => ({
            key: name,
            label: name,
            active: cat === name,
            cat: name
          }))
        ]
      }
      const children = ctx.section.children
      if (children && children.length) {
        if (ctx.layout === 'directory') return []
        return children.map((child) => ({
          key: child.path,
          label: child.label,
          active: this.$route.path === child.path,
          path: child.path
        }))
      }
      if (categories.length) {
        const cat = this.front.partyCategoryFilter || ''
        return [
          { key: '', label: '全部', active: !cat, cat: '' },
          ...categories.map((name) => ({
            key: name,
            label: name,
            active: cat === name,
            cat: name
          }))
        ]
      }
      return []
    },
    showSubnav() {
      return this.subnavItems.length > 0
    }
  },
  methods: {
    onSubnavSelect(item) {
      if (!item) return
      if (item.path) {
        this.front.goPath(item.path)
        return
      }
      const sectionPath = this.ctx && this.ctx.section && this.ctx.section.path
      if (sectionPath && this.$route.path !== sectionPath) {
        const query = { ...this.$route.query }
        if (item.cat) {
          query.cat = item.cat
        } else {
          delete query.cat
        }
        this.$router.replace({ path: sectionPath, query }).catch(() => {})
        return
      }
      this.front.setPartyCategory(item.cat || '')
    }
  }
}
</script>
